import { Route, createBrowserRouter, createRoutesFromElements, Navigate } from 'react-router-dom';

import App from './App';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import Login from './pages/Login';
import CreateNewPassword from './pages/CreateNewPassword';
import ForgotPassword from './pages/ForgotPassword';
import CreateAccount from './pages/CreateAccount';
import PersonalizedForm from './pages/PersonalizedForm';
import GuestOnlyRoute from './common/GuestOnlyRoute';
import PrivateRoute from './common/PrivateRoute';
import Profile from './pages/private/Profile';
import UserInfoWrapper from './common/UserInfoWrapper';
import CodeValidation from './pages/CodeValidation';
import RedirectFacebook from './pages/RedirectFacebook';
import Landing from './pages/Landing';
import MyTrips from './pages/private/MyTrips';
import TripDetails from './pages/private/TripDetails';
import MyIdeas from './pages/private/MyIdeas';
import IdeaDetails from './pages/private/IdeaDetails';
import Discover from './pages/private/Discover/Discover';
import ReferralLand from './pages/ReferralLand';

const isProd = window.location.hostname === 'travgenius.ai' ||
               window.location.hostname === 'www.travgenius.ai';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/"
      element={<App />}
    >
      <Route
        path="/users/referral/land/:token"
        element={<ReferralLand />}
      />

      {isProd && (
        <Route path="*" element={<Navigate to="/insider" replace />} />
      )}

      <Route element={<GuestOnlyRoute />}>
        <Route
          index={true}
          path="/sign-in"
          element={<SignIn />}
        />
        <Route
          path="/sign-up"
          element={<SignUp />}
        />
        <Route
          path="/login"
          element={<Login />}
        />
        <Route
          path="/forgot-password"
          element={<ForgotPassword />}
        />
        <Route
          path="/create-account"
          element={<CreateAccount />}
        />
      </Route>
      <Route
        path="/create-new-password"
        element={<CreateNewPassword />}
      />
      <Route
        path="/personalized-form"
        element={<PersonalizedForm />}
      />
      <Route
        path="/reset-password"
        element={<CodeValidation />}
      />
      <Route
        path="/sign-up/facebook"
        element={<RedirectFacebook />}
      />
      <Route
        path="/insider"
        element={<Landing />}
      />

      <Route
        path=""
        element={<PrivateRoute />}
      >
        <Route
          path="/"
          element={<UserInfoWrapper />}
        >
          <Route
            index
            element={<Navigate to="/profile" replace />}
          />
          <Route
            path="/profile"
            element={<Profile />}
          />
          <Route
            path="/trips"
            element={<MyTrips />}
          />
          <Route
            path="/trips/:id"
            element={<TripDetails />}
          />
          <Route
            path="/ideas"
            element={<MyIdeas />}
          />
          <Route
            path="/ideas/:id"
            element={<IdeaDetails />}
          />
          <Route
            path="/discover"
            element={<Discover />}
          />
        </Route>
      </Route>
    </Route>
  ),
  {
    future: {
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipCatchAllRevalidation: true,
      v7_startTransition: true,
      v7_skipActionErrorRevalidation: true,
    } as any,
  }
);
